import { Controller } from "@hotwired/stimulus"

// The investments hero holds one chart per mode (Performance, Balances) and
// period (1W, 1M, ...), all rendered by the server. This shows the one that
// matches the picked mode and period, and lights both pills. Each chart runs
// its own reports-chart scrubber; this controller only chooses which is seen.
export default class extends Controller {
  static targets = ["panel", "mode", "period"]
  static values = { mode: String, period: String }

  pickMode(event) {
    this.modeValue = event.currentTarget.dataset.mode
  }

  pickPeriod(event) {
    this.periodValue = event.currentTarget.dataset.period
  }

  modeValueChanged() { this.#render() }
  periodValueChanged() { this.#render() }

  #render() {
    if (!this.modeValue || !this.periodValue) return

    this.panelTargets.forEach(panel => {
      panel.classList.toggle("is-active", panel.dataset.mode === this.modeValue && panel.dataset.period === this.periodValue)
    })
    this.modeTargets.forEach(pill => this.#select(pill, pill.dataset.mode === this.modeValue))
    this.periodTargets.forEach(pill => this.#select(pill, pill.dataset.period === this.periodValue))
  }

  #select(pill, on) {
    pill.classList.toggle("is-active", on)
    pill.setAttribute("aria-selected", on)
  }
}
